import React from "react";
import { motion } from "framer-motion";

export default function ZenBackground() {
    return (
        <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
            {/* Base Breathing Gradient */}
            <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-purple-50 to-white dark:from-gray-900 dark:via-gray-900 dark:to-gray-800 animate-gradient-slow opacity-80" />

            {/* Organic Shape 1 (Top Left) */}
            <motion.div
                animate={{
                    x: [0, 30, -20, 0],
                    y: [0, -40, 20, 0],
                    scale: [1, 1.1, 0.9, 1],
                }}
                transition={{
                    duration: 20,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
                className="absolute -top-40 -left-40 w-96 h-96 bg-blue-200/30 dark:bg-blue-900/10 rounded-full blur-3xl mix-blend-multiply dark:mix-blend-screen filter"
            />

            {/* Organic Shape 2 (Bottom Right) */}
            <motion.div
                animate={{
                    x: [0, -40, 30, 0],
                    y: [0, 50, -30, 0],
                    scale: [1, 1.2, 0.8, 1],
                }}
                transition={{
                    duration: 25,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: 2,
                }}
                className="absolute -bottom-40 -right-40 w-[30rem] h-[30rem] bg-purple-200/30 dark:bg-purple-900/10 rounded-full blur-3xl mix-blend-multiply dark:mix-blend-screen filter"
            />

            {/* Organic Shape 3 (Center - Subtle) */}
            <motion.div
                animate={{
                    x: [-20, 20, -20],
                    y: [-20, 20, -20],
                }}
                transition={{
                    duration: 15,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
                className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[40rem] h-[40rem] bg-indigo-100/20 dark:bg-indigo-900/5 rounded-full blur-3xl opacity-50"
            />
        </div>
    );
}
